export const STATUSES =  {
  // желтые
  init: {
    label: "Новая заявка",
    bgColor: "#FAE6AA",
    textColor: "#B79310",
    description:
      "Мы получили заявку и свяжемся с клиентом в ближайшие 10—20 минут. Если статус заявки не поменяется за сутки, это значит, что мы пока не дозвонились до клиента.",
  },
  waitformeeting: {
    label: "Ожидание встречи",
    bgColor: "#FAE6AA",
    textColor: "#B79310",
  },
  'meeting.process': {
    label: "Назначена встреча",
    bgColor: "#FAE6AA",
    textColor: "#B79310",
    description:
      "Мы назначили встречу клиенту. На встрече клиент подпишет заявление, и после этого мы откроем расчётный счёт.",
  },
  waitforcoownersdata: {
    label: "Ввод данных",
    bgColor: "#FAE6AA",
    textColor: "#B79310",
  },
  waitforuploaddocs: {
    label: "Загрузка паспортов",
    bgColor: "#FAE6AA",
    textColor: "#B79310",
  },
  process: {
    label: "В работе",
    bgColor: "#FAE6AA",
    textColor: "#B79310",
    description:
      "Мы дозвонились до клиента и зарегистрировали его в системе, а теперь проверяем документы. Если с документами всё в порядке, назначим встречу.",
  },
  // зеленые
  success: {
    label: "Счет открыт",
    bgColor: "#D4F296",
    textColor: "#5E8C00",
    description: "Клиент открыл счёт в банке.",
  },
  // красные
  decline: {
    label: "Отказ банка",
    bgColor: "#F9C1BD",
    textColor: "#A61D1D",
    description:
      "Банк отказал клиенту в открытии счёта. Это может быть связано с недостоверными данными, блокировками или приостановками по счёту."
  },
  error: {
    label: "Ошибка",
    bgColor: "#F9C1BD",
    textColor: "#A61D1D",
  },
  "decline.client": {
    label: "Отказ клиента",
    bgColor: "#F9C1BD",
    textColor: "#A61D1D",
    description: "Клиент отказался от открытия счёта.",
    hint: "Для пересмотра отказа обратитесь в поддержку"
  },
  // серые
  "decline.double": {
    label: "Дубль",
    bgColor: "#EEEEEE",
    textColor: "#808080",
    description: "Данные дублируются. С этим клиентом мы уже работаем.",
  },
  "archive": {
    label: "Архив",
    bgColor: "#EEEEEE",
    textColor: "#808080",
  }
};
